import { useEffect } from "react";
import "./AddGMP.scss";
import { Button } from "..";
import { useNavigate } from "react-router-dom";
import { routes } from "../../routes/routes.constatns";
import { useDispatch, useSelector } from "react-redux";
import { GMPParameters } from "./GMPParameters/GMPParameters";
import { GMPTable } from "./GMPTable/GMPTable";
import { setHierarchialData } from "../../store/slices/projectSlice";
import {
  setGMPDetails,
  setSelectedGMPRowIndex,
  setselectedUIAllFilters,
} from "../../store/slices/gmpSlice";
import {
  getFinancialParametersHrchyData
} from "../../store/services/engagement.service";
import { getGMPData } from "../../store/services/gmp.service";
import { Tooltip } from "../CommonUIComponents/Tooltip/Tooltip";
import { EmissionIcon } from "../../icons";
import { addGMPTooltip } from "../../util/constants";
import { FinancialParameterCreation, CloseBtn } from "../../util/constants";

export function AddGMP() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const steps = useSelector((state) => state.stepper.steps);
  const engagement = useSelector((state) => state.engagement.engagement);
  const project = useSelector((state) => state.project.project);
  const selectedRegion = useSelector(
    (state) => state.engagement.selectedRegion
  );
  const currentStep = useSelector((state) => state.engagement.currentStep);

  // Fetching GMP details
  const getGMPDetails = async () => {
    const request = {
      engagement: engagement.engagementCode,
      viewType: "Default",
    };
    const data = await getGMPData({ request });
    dispatch(setGMPDetails({ gmpData: data }));
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (engagement?.id) {
      //Fetching hierarchy data and creating redux state for it.
      const hierarchyData = async () => {
        const request = {
          engagementCode: engagement.engagementCode,
        };
        
        const data = await getFinancialParametersHrchyData({ request });
        dispatch(setHierarchialData({ hierarchialData: data?.data?.hierarchicalData }));
      };
      hierarchyData();
      getGMPDetails();
    }
  }, [engagement?.id, dispatch, getGMPDetails]);
  /* eslint-enable react-hooks/exhaustive-deps */

  // Handle cancel button onclick
  function handleCancelClick() {
    dispatch(setSelectedGMPRowIndex({ rowDataIndex: null }));
    dispatch(setselectedUIAllFilters({ selectedUIAllFilters: {} }));
    if (project?.projectId) {
      navigate(
        `/${routes.createNewEngagement}/${routes.createNewProject}?projectId=${project?.projectId}`,
        {
          state: {
            engagementId: engagement.id,
            regionId: selectedRegion.id,
          },
          gestureEnabled: false,
        }
      );
    } else {
      navigate(`/${routes.createNewEngagement}`, {
        state: {
          engagementId: engagement.id,
          regionId: selectedRegion.id,
        },
        gestureEnabled: false,
      });
    }
  }

  return (
    <div className="add-gmp">
      <div className="add-gmp-header">
        <div className="add-gmp-header-title">
          {steps[currentStep]?.stepHeading}
        </div>
        <div className="add-gmp-header-stepper"></div>
      </div>

      <div className="add-gmp-content">
        <div className="add-gmp-content-header">
          <div className="add-gmp-content-header-main">
            <span className="add-gmp-content-header-main-analyse">
              {FinancialParameterCreation}
            </span>
            <Tooltip
              trigger={<EmissionIcon />}
              variant="ghost"
              tooltipText={addGMPTooltip}
            ></Tooltip>
          </div>
        </div>
        <div className="add-gmp-content-body">
          <GMPParameters />
          <GMPTable />
          <div className="add-gmp-footer">
            <Button variant="secondary" onClick={handleCancelClick}>
              {CloseBtn}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
